import batchallComponent from './batch.all.component';

let batchallModule = angular.module('batchall', [
	])

	.component('batchall', batchallComponent)

	.name;

export default batchallModule;


// WEBPACK FOOTER //
// ./client/app/components/batch/all/index.js